<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"> {{ $t("messages.titTblBillingInfo") }} </span>
    </div>
    <!-- 2022.03.14 수정 -->
    <div class="ly-flex">
      <div class="table-count">
        {{ $t("messages.all") }}
        <span>{{ count }}</span>
        {{ $t("messages.unit") }}
        {{ $t("messages.lblRateInformation") }}
      </div>
      <el-button plain size="small" type="excel" @click="excelDownload"
        >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
      ></el-button>
      <!--
      <el-button size="small" type="save" @click="isModal">{{
        $t("messages.btnStoragePayment")
      }}</el-button>
      -->
    </div>
    <!-- //2022.03.14 수정 -->
    <!-- <div class="ly-sort ly-sort-his"> -->
    <!-- </div> -->
    <div class="table-body">
      <idc-list :tableHeader="tableHeader" :tableData="tableData" />
      <!-- <idc-pagenation
        :pageInfo.sync="pageInfo"
        layout="prev, pager, next "
        :total="count"
        @movePage="getBillDtlTxnLastList"
      ></idc-pagenation> -->
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcPagenation from "@/components/common/IdcPagenation";
import { getNow, commonExcelDownload } from "@/assets/js/common.js";

export default {
  props: {
    // svcContId: {
    //   default: "",
    // },
    custId: {
      type: String,
      default: "",
    }
  },
  components: {
    IdcList,
    IdcPagenation,
  },
  computed: {
    count() {
      return this.tableData.length;
    },
    tableHeader(){
      return [
        {
          prop: "pmtStatusNm",
          //label: "수납상태",
          label: this.$t("messages.lblStorageStatus"),
          width: 131,
        },
        {
          prop: "iaId",
          //label: "청구계약아이디",
          label: this.$t("messages.lblBillingContractId"),
          width: 131,
        },
        {
          prop: "dueDate",
          //label: "납기일",
          label: this.$t("messages.lblDueDate"),
          width: 131,
        },
        {
          prop: "totInvAmt",
          //label: "총청구금액",
          label: this.$t("messages.lblTotalBilledAmount"),
          width: 178,
        },
        {
          prop: "invAmt",
          //label: "당월청구금액",
          label: this.$t("messages.lblThisMonthBilledAmount"),
          width: 178,
        },
        {
          prop: "pmtAmt",
          //label: "당월수납금액",
          label: this.$t("messages.lblThisMonthStorageAmount"),
          width: 178,
        },
      ];
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.getBillDtlTxnLastList();
  },
  methods: {
    getBillDtlTxnLastList() {
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Cus.getBillDtlTxnLastList, {
          custId : this.custId
        })
        .then((res) => {
          console.log(res);

          if (res.data !== "") {
            res.data.resData.map((data) => {
              data.totBillAmt = String(data.totBillAmt).replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              );
            });
            this.tableData = res.data.resData;
          } else {
            this.tableData = [];
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    // 2022.03.14 추가
    isModal() {
      this.$emit("isModal");
    },
    // 2022.03.14 추가
    excelDownload(){
      if(this.tableData.length == 0){
        alert(this.$t("messages.msgNodata"));
        return;
      }
      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService,
        "요금정보 목록_" + getNow() + ".xlsx",
        "getBillDtlTxnLastList",
        this.tableHeader,
        { custId : this.custId }
      );
    }
  },
};
</script>

<style lang="scss" scoped>
// 2022.03.14 추가
.ly-flex {
  padding-bottom: 10px;
}
// 2022.03.14 추가


.excel-downBtn{
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
}
</style>
